/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Indra Adian",
  title: "Hi all, I'm Indra",
  subTitle: emoji(
    "A passionate Full Stack Software Developer with a deep focus on the .NET ecosystem. I specialize in building scalable, enterprise-grade applications using ASP.NET Core, Blazor, and Clean Architecture. I am highly experienced in designing robust backend systems with the Repository & Unit of Work patterns and optimizing SQL Server for high-performance data reporting."
  ),
  resumeLink:
    "/resume.pdf", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/indraadian",
  linkedin: "https://www.linkedin.com/in/indra-adiansyahroni-ba2a16204/",
  gmail: "indraadian15@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  stackoverflow: "https://stackoverflow.com/users/16258532/adian",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "PASSIONATE FULL STACK DEVELOPER SPECIALIZING IN .NET ECOSYSTEM & CLEAN ARCHITECTURE",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces using Blazor (WebAssembly/Server) and ASP.NET Core"
    ),
    emoji(
      "⚡ Architecting scalable backend systems with Clean Architecture, Repository Pattern, and Unit of Work"
    ),
    emoji(
      "⚡ Database design and optimization using SQL Server, including SSRS for complex data reporting"
    ),
    emoji(
      "⚡ Building real-time web functionalities and interactive dashboards using SignalR"
    )
  ],

  /* Menggunakan ikon yang relevan dengan C#, .NET, dan SQL Server */
  softwareSkills: [
    {
      skillName: "C#",
      fontAwesomeClassname: "fas fa-code" // Ikon umum untuk koding
    },
    {
      skillName: ".NET Core",
      fontAwesomeClassname: "fab fa-windows" // Sering digunakan untuk ekosistem Microsoft
    },
    {
      skillName: "ASP.NET Core",
      fontAwesomeClassname: "fas fa-server"
    },
    {
      skillName: "Blazor",
      fontAwesomeClassname: "fas fa-cubes"
    },
    {
      skillName: "SQL Server",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Bootstrap",
      fontAwesomeClassname: "fab fa-bootstrap"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Azure",
      fontAwesomeClassname: "fab fa-microsoft"
    }
  ],
  display: true
};

// Education Section

const educationInfo = {
  display: true, 
  schools: [
    {
      schoolName: "Universitas Bani Saleh Bekasi",
      logo: require("./assets/images/baniSalehLogo.png"), // Pastikan nama file logo sesuai
      subHeader: "Bachelor of Computer Science (S.Kom) in Informatics Engineering",
      duration: "2016 - 2020",
      desc: "Focused on Software Engineering and Information Systems, maintaining a strong interest in application development and database management.",
      descBullets: [
        "Focused on Software Engineering, Database Systems, and Web Development.",
        "Developed a solid foundation in Algorithm Design and Object-Oriented Programming (OOP)."
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend Development (.NET/C#)", 
      progressPercentage: "90%" 
    },
    {
      Stack: "Database & SQL Optimization",
      progressPercentage: "85%"
    },
    {
      Stack: "Frontend (Blazor/Bootstrap)",
      progressPercentage: "75%"
    },
    {
      Stack: "System Architecture",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: true ,
  display: true // Set false to hide this section, defaults to true
};
// Work experience section

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Web Engineer Specialist",
      company: "PT. Intersoft Solutions",
      companylogo: require("./assets/images/intersoftLogo.png"),
      date: "May 2022 – Present",
      desc: "Developed and maintained enterprise web applications using ASP.NET Web Forms and C#, focusing on omnichannel solutions.",
      descBullets: [
        "Led the integration of major marketplaces (Tokopedia, Shopee, TikTok, Lazada, and Blibli) into a centralized omnichannel system.",
        "Streamlined product, order, and inventory management through real-time RESTful API synchronization.",
        "Optimized backend logic, API security, and system scalability to handle high-volume enterprise data.",
        "Collaborated with cross-functional teams (QA, UI/UX) to ensure reliable and user-centric workflows."
      ]
    },
    {
      role: "Software Developer",
      company: "PT. Idooh Bersama Indonesia",
      companylogo: require("./assets/images/idoohLogo.png"),
      date: "April 2021 – March 2022",
      desc: "Designed and developed modern software applications using .NET Core and C#.",
      descBullets: [
        "Architected clean, efficient, and maintainable code for both new projects and existing systems.",
        "Upgraded and refactored legacy applications, significantly improving performance and system reliability.",
        "Performed rigorous testing and debugging to ensure high-quality software delivery.",
        "Worked closely with UX designers and analysts to translate business requirements into technical solutions."
      ]
    },
    {
      role: "Back-End Developer",
      company: "PT. Starlabs Global Teknologi",
      companylogo: null, // Set ke null jika tidak ada gambar
      companyIcon: "fas fa-building", // Ik
      date: "March 2019 – April 2020",
      desc: "Focused on server-side logic and cloud infrastructure support.",
      descBullets: [
        "Developed and maintained robust backend services and APIs using C# and .NET technologies.",
        "Provided cloud support services, including infrastructure monitoring and performance checks.",
        "Collaborated with cloud engineers to maintain system documentation and ensure operational stability."
      ]
    },
    {
      role: "Technical Support",
      company: "PT. Telkom Akses",
      companylogo: require("./assets/images/telkomLogo.png"),
      date: "September 2018 – February 2019",
      desc: "Delivered technical infrastructure support and network installation.",
      descBullets: [
        "Installed and configured fiber optic networks for residential and business customers.",
        "Provided technical troubleshooting and real-time support for internet connectivity issues.",
        "Ensured successful service activation and provided user guidance on network hardware."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "ENTERPRISE SOLUTIONS AND APPLICATIONS I'VE HELPED TO ARCHITECT & BUILD",
  projects: [
    {
      image: require("./assets/images/iSellerLogo.png"), 
      projectName: "iSeller",
      projectDesc: "Developed a centralized marketplace integration system within the iSeller ecosystem. Specifically focused on architecting seamless API connections with major marketplaces like Tokopedia, Shopee, and TikTok to synchronize orders, products, and inventory in real-time.",
      footerLink: [
        {
          name: "Visit iSeller",
          url: "https://www.isellercommerce.com/"
        }
      ]
    },
    {
      image: require("./assets/images/wargakooLogo.png"),
      projectName: "Wargakoo",
      projectDesc: "Designed and developed a digital population management application during my tenure at PT. Idooh. Focused on building a reliable system for citizen data administration, ensuring data integrity and a smooth user experience for community management.",
      footerLink: [
        {
          name: "Project Info",
          url: "https://idooh.co.id/"
        }
      ]
    }
  ],
  display: true 
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },
    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+62 822-3147-8054",
  email_address: "indraadian15@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
